import { 
 
    DATOS_LOGIN,
    ENVIAR_LOGIN,
    ALERTA_USUARIO,
    CORREO_RECUPERAR,
    ENVIAR_RECUPERAR,
    ALERTA_RECUPERAR,
    ALERTA_RECUPERAR_STR,
    DATOS_MODIFICAR,
    ENVIAR_MODIFICAR,
    ALERTA_MODIFICAR,
    ALERTA_MODIFICAR_STR,
    ALERTA_MODIFICAR_CLASS,
    ALERTA_USUARIO_STR
} from '../../Types';

export default ( state, action ) => {

    switch(action.type){
        
        case DATOS_LOGIN:
            return{
                ...state,
                datos_login: action.payload
            }
        
        case ENVIAR_LOGIN:
            return{
                ...state,
                enviar_login: action.payload
            }

        case ALERTA_USUARIO:
            return{
                ...state,
                alerta_usuario: action.payload
            }

        case CORREO_RECUPERAR:
            return{
                ...state,
                correo_recuperar: action.payload
            }
                        
        case ENVIAR_RECUPERAR:
            return{
                ...state,
                enviar_recuperar: action.payload
            }

        case ALERTA_RECUPERAR:
            return{
                ...state,
                alerta_recuperar: action.payload
            }
            
        case ALERTA_RECUPERAR_STR:
            return{
                ...state,
                alerta_recuperar_str: action.payload
            }

        case DATOS_MODIFICAR:
            return{
                ...state,
                datos_modificar: action.payload
            }

        case ENVIAR_MODIFICAR:
            return{
                ...state,
                enviar_modificar: action.payload
            }

        case ALERTA_MODIFICAR:
            return{
                ...state,
                alerta_modificar: action.payload
            }
        
        case ALERTA_MODIFICAR_STR:
            return{
                ...state,
                alerta_modificar_str: action.payload
            }

        case ALERTA_MODIFICAR_CLASS:
            return{
                ...state,
                alerta_modificar_class: action.payload
            }

        case ALERTA_USUARIO_STR:
            return{
                ...state,
                alerta_usuario_str: action.payload
            }
        default:
        return state;
    }

}